/* Shared one-time quantity pricing. Shopify enforces eligibility and combinations. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.PNDiscounts = api;
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  function percent(jars) { return Number(jars) >= 3 ? 20 : Number(jars) >= 2 ? 15 : 0; }
  function quantity(cart, productIds) {
    var ids = (productIds || []).map(String);
    return (cart.items || []).reduce(function (total, item) {
      return total + (!item.selling_plan_allocation && ids.indexOf(String(item.product_id)) >= 0 ? Number(item.quantity) || 0 : 0);
    }, 0);
  }
  function codes(cart) {
    var found = [], seen = Object.create(null);
    function add(code) {
      if (typeof code !== 'string') return;
      code = code.trim(); var key = code.toLowerCase();
      if (!code || seen[key]) return;
      seen[key] = true; found.push(code);
    }
    function application(value) { if (value && value.type === 'discount_code') add(value.title); }
    // Keep saved coupons even when the customer hasn't qualified for them yet.
    (cart.discount_codes || []).forEach(function (value) { if (value) add(value.code); });
    (cart.cart_level_discount_applications || []).forEach(application);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (value) { application(value.discount_application); });
    });
    return found;
  }
  function update(cart, productIds, configured) {
    configured = configured || {15: 'PN-ONETIME-15', 20: 'PN-ONETIME-20'};
    var discount = percent(quantity(cart, productIds));
    var wanted = discount ? String(configured[discount] || '').trim() : '';
    var known = Object.keys(configured).map(function (key) { return String(configured[key]).toLowerCase(); });
    function managed(code) { return /^(PN-ONETIME-(10|15|20)|WELCOME10)$/i.test(code) || known.indexOf(code.toLowerCase()) >= 0; }
    var existing = codes(cart), old = existing.filter(managed);
    if ((!wanted && !old.length) || (wanted && old.length === 1 && old[0].toLowerCase() === wanted.toLowerCase())) return null;
    var next = existing.filter(function (code) { return !managed(code); });
    if (wanted) next.push(wanted);
    // Shopify chooses the eligible non-combining discount with the best value.
    // Subscription selling-plan prices remain Shopify's source of truth.
    return next.join(',');
  }
  function applyCampaignDiscount(win) {
    var code = new URLSearchParams(win.location.search).get('discount');
    if (!code) return Promise.resolve(null);
    var rootPath = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/').replace(/\/$/, '');
    function responseJSON(response) {
      if (!response.ok) throw new Error('Could not apply your offer. Please try again.');
      return response.json();
    }
    // Direct PDP links preserve attribution. Apply the accompanying coupon via
    // Shopify's Cart API, retaining other codes and leaving all quantities alone.
    return win.fetch(rootPath + '/cart.js', {credentials:'same-origin', cache:'no-store'})
      .then(responseJSON).then(function (cart) {
        var existing = codes(cart);
        if (existing.some(function (value) { return value.toLowerCase() === code.toLowerCase(); })) return cart;
        existing.push(code);
        return win.fetch(rootPath + '/cart/update.js', {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({discount:existing.join(',')})
        }).then(responseJSON);
      });
  }
  return {percent:percent, quantity:quantity, codes:codes, update:update, applyCampaignDiscount:applyCampaignDiscount};
});
